import { createStore } from "vuex"

export const store = createStore(
  {
    state: {},
    mutations: {},
    actions: {}
  }
)